module.exports = __webpack_public_path__ + "static/img/8areaB_03.b41e415.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_03.png
// module id = 1223
// module chunks = 1